import API from 'services/API';
import { createPropertyObject } from 'modules/App/utils/helpers';

export default function getFilteredPropertyObjects() {
  return API.request({
    method: 'GET',
    url: '/property/all?filter=NOT_BELONG_USER',
    mapper: (data) => data.map(createPropertyObject).filter((object) => object),
  });
}
